import ResponseDataExtractor from '../../../../common/utils/ResponseDataExtractor';
import ErrorHandle from '../../../../common/utils/ErrorHandle';
import router from '../../../../router';
import helper from '../../../../helper';

export default {
	loginProcess({ commit }, { email, password }) {
        commit('SET_PAGE', { loading: true });
        commit('SET_AUTH', { error: '' });
        
        axios.post(process.env.MIX_API_URL + 'auth/user', {
            email,
            password
        }, {
            timeout: 30000
        })
            .then(response => new ResponseDataExtractor(response).data)
            .then(data => {
                if (data.hasOwnProperty('outcome') && data.outcome.error == 'true') {
                    commit('SET_AUTH', {
                        error: data.outcome.message
                    });
                    commit('SET_PAGE', {
                        loading: false
                    });
                } else {
                    commit('SET_AUTH', data);
                    this.dispatch('setTokenBearer');
                    this.dispatch('getUser', email);
                    //router.push('/booking');
                }
            })
            .catch(e => {
                const { statusCode, error } = new ErrorHandle(e).format;
                if(statusCode == 408) {
                    axios.post(process.env.MIX_API_URL +  'utility/send-failed-api-notification', {
                        'request_uri': 'POST auth/user'
                    });
                }

                commit('SET_AUTH', {
                    token_hash: e.response.data.token_hash,
                    error
                });
                commit('SET_PAGE', {
                    loading: false
                });
            });
    },
    clearAuthError({ commit }) {
        commit('SET_AUTH', { error: null });
    },
    logout({
        commit
    }) {
        axios.get(process.env.MIX_API_URL + 'auth/invalidate')
            .then(() => {
                this.dispatch('logoutSuccess');
            }, {
                timeout: 30000
            })
            .catch(e => {
                console.error('Error when logout', helper.errorCatch(e));
                this.dispatch('logoutSuccess');
            });

    },
    async logoutSuccess({
        commit
    }) {
        await commit('SET_AUTH', {
            access_token: null,
            token_type: null,
            expires_in: 0
        });
        await this.dispatch('setTokenBearer');
        await this.dispatch('setBasicDetails', '');
        localStorage.removeItem('currentAddressBookings');
        setTimeout(() => {
            this.dispatch("setBookingHistoryAddress", null);
        }, 300)
        router.push('/');
    },
    setTokenBearer({
        commit,
        state
    }) {
        window.axios.defaults.headers.common['Authorization'] = state.auth.access_token ? 'Bearer ' + state.auth.access_token : '';
        localStorage.AuthToken = window.axios.defaults.headers.common['Authorization'];
    },
    setBasicDetails({
        commit
    }, data) {
        localStorage.BasicDetails = data ? JSON.stringify(data) : '';
    },
}